<wl-busy class="mt-27" *ngIf="!managementCompanyDto"></wl-busy>
<div class="mt-27 mct-flex mct-col mct-gap-10" *ngIf="managementCompanyDto"  >
  <div class="mct-flex mct-col" >
    <label>{{ 'profiles.edit.profile-type.total-number-of-units-for-related-properties' | translate | titlecase }}</label>
    <span class="f-wb">{{ managementCompanyDto?.TotalUnitsInPortfolio }}</span>
  </div>

  <form #overrideForm="ngForm">
    <div class="mct-flex mct-col" >
      <label>{{ 'profiles.edit.profile-type.override-number-of-units-managed' | translate | titlecase }}</label>
      <input name="override" type="number" [(ngModel)]="unitsInPortfolioOverride" (change)="overrideChanged()" />
    </div>
  </form>
</div>
